import { Response } from '../services/backendService/types';
import { findShortestColumn } from './gameUtil';
export const makeGridColumns = (
  responsesArray: Response[],
  slideWrapperWidth: number,
) => {
  const numberOfColumns =
    slideWrapperWidth <= 669
      ? 1
      : slideWrapperWidth <= 1019
      ? 2
      : slideWrapperWidth <= 1439
      ? 3
      : 4;

  const columnOne: Response[] = [];
  const columnTwo: Response[] = [];
  const columnThree: Response[] = [];
  const columnFour: Response[] = [];

  const addToColumn = (response: Response, shortestColumn: number) => {
    return shortestColumn === 1
      ? columnOne.push(response)
      : shortestColumn === 2
      ? columnTwo.push(response)
      : shortestColumn === 3
      ? columnThree.push(response)
      : columnFour.push(response);
  };

  let count = 0;
  responsesArray.forEach(response => {
    if (count + 1 > numberOfColumns) {
      count = 1;
    } else {
      count = count + 1;
    }

    const shortestColumn = findShortestColumn(
      {
        columnOne,
        columnTwo,
        columnThree,
        columnFour,
      },
      slideWrapperWidth,
    );
    addToColumn(response, shortestColumn);
  });

  const resultsInColumns = [columnOne, columnTwo, columnThree, columnFour];
  return resultsInColumns;
};
